import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { MapContainerComponent } from './components/map-container/map-container.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSliderModule } from '@angular/material/slider';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatIconModule} from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatChipsModule} from '@angular/material/chips';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ServeisComponent } from './components/serveis/serveis.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CercadorSwitchComponent } from './components/cercador-switch/cercador-switch.component';
import { AlertesComponent } from './components/alertes/alertes.component';
import { RutesComponent } from './components/rutes/rutes.component';
import { TraficComponent } from './components/trafic/trafic.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule} from '@angular/material/core';
import { HttpClientModule }    from '@angular/common/http';
import { Ng5SliderModule } from 'ng5-slider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderComponent } from './components/shared/loader/loader.component';
import { LoaderService } from './services/loader.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from './services/loader.interceptor';
import { MatDialogModule } from '@angular/material/dialog';
import { ZoomDialogComponent } from './components/zoom-dialog/zoom-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { CheckboxesService } from './services/checkboxes.service';
import { IncidenciaComponent } from './components/markers/incidencia/incidencia.component';
import { LlistaIncidenciesComponent } from './components/llista-incidencies/llista-incidencies.component';
import { IncidenciaLlistaComponent } from './components/markers/incidencia-llista/incidencia-llista.component';
import { CameraComponent } from './components/markers/camera/camera.component';
import { RadarComponent } from './components/markers/radar/radar.component';
import { ParkingComponent } from './components/markers/parking/parking.component';
import { ParkNRideComponent } from './components/markers/park-nride/park-nride.component';
import { GasStationComponent } from './components/markers/gas-station/gas-station.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TramPerillComponent } from './components/markers/tram-perill/tram-perill.component';
import { DirectionsService } from './services/directions.service';
import { LlistaRutesComponent } from './components/llista-rutes/llista-rutes.component';
import { FuelDialogComponent } from './components/fuel-dialog/fuel-dialog.component';
import { BotonsComponent } from './components/botons/botons.component';
import { AppRoutingModule } from './app-routing.module';
import { PrintDirectionsComponent } from './components/print-directions/print-directions.component';
import { ShareDialogComponent } from './components/share-dialog/share-dialog.component';
import localeCa from '@angular/common/locales/ca';
import { registerLocaleData } from '@angular/common';


registerLocaleData(localeCa);

@NgModule({
  declarations: [
    AppComponent,
    MapContainerComponent,
    ServeisComponent,
    CercadorSwitchComponent,
    AlertesComponent,
    RutesComponent,
    TraficComponent,
    LoaderComponent,
    ZoomDialogComponent,
    IncidenciaComponent,
    LlistaIncidenciesComponent,
    IncidenciaLlistaComponent,
    CameraComponent,
    RadarComponent,
    ParkingComponent,
    ParkNRideComponent,
    GasStationComponent,
    TramPerillComponent,
    LlistaRutesComponent,
    FuelDialogComponent,
    BotonsComponent,
    PrintDirectionsComponent,
    ShareDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatButtonToggleModule,
    MatIconModule,
    MatSlideToggleModule,
    MatChipsModule,
    MatCardModule,
    MatInputModule,
    MatToolbarModule,
    MatTabsModule,
    FlexLayoutModule,
    MatCheckboxModule,
    MatSelectModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    HttpClientModule,
    Ng5SliderModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatButtonModule,
    FontAwesomeModule,
    AppRoutingModule,
    MatProgressBarModule
  ],
  entryComponents: [
    ZoomDialogComponent, IncidenciaComponent, CameraComponent, RadarComponent, ParkingComponent,
    ParkNRideComponent, GasStationComponent, TramPerillComponent, FuelDialogComponent, ShareDialogComponent
  ],

  providers: [
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    CheckboxesService,
    DirectionsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
